/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssegnazioneArticoloCedolaWithChainDTO { 
    id?: string;
    titolo?: string;
    editore?: string;
    area?: string;
    volume?: string;
    note?: string;
    valore?: number;
    attivo?: boolean;
    version?: number;
    created_at?: string;
    updated_at?: string;
    istituto_id?: string;
    istituto_nome?: string;
    plesso_id?: string;
    plesso_nome?: string;
    assegnazione_id?: string;
    classe?: string;
    sezione?: string;
}

